/* LGB Elite Greenhouses extras panel (18 Oct 2026).
   Driven by window.LGBEliteAddons, set in snippets/lgb-elite-addons.liquid.
   Elite accessories are sold by "Item" (not by size), so each row has a drop-down
   of the items in that accessory product. Where the accessory comes in lengths
   (crestings, soil bed divider) the length is matched to the greenhouse.
   Where the accessory has a Finish option, the variant always matches the
   greenhouse's own finish (aluminium or powder coated), and the chosen powder
   coating colour is carried onto those accessory lines too.
   Uses the same .lgb-adds markup as the other panels so the running total
   picks the ticked extras up. Nothing is ever pre-ticked. If anything fails,
   the page behaves exactly as it always has. */
(function () {
  var CFG = window.LGBEliteAddons;
  if (!CFG || !CFG.productHandle || !CFG.rows || !CFG.rows.length) return;

  var VISIBLE = 2;
  var product = null, acc = {}, lastKey = null, busy = false, expanded = false;
  var state = {}; /* state[key] = { on: bool, item: string, qty: number } */
  function qtyOf(key) { return (state[key] && state[key].qty) || 1; }

  function money(c) {
    var d = (c % 100 === 0) ? 0 : 2;
    return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rx(s) { return s ? new RegExp(s, 'i') : null; }
  function mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function idInputOf(f) { return f ? f.querySelector('input[name="id"]') : null; }
  function optNames(p) {
    return (p.options || []).map(function (o) { return (typeof o === 'string') ? o : ((o && o.name) || ''); });
  }
  function vals(v) { return [v.option1, v.option2, v.option3]; }

  function currentVariant() {
    var inp = idInputOf(mainForm());
    if (!inp || !product) return null;
    var found = null;
    product.variants.forEach(function (v) { if (String(v.id) === String(inp.value)) found = v; });
    return found;
  }
  function optOf(v, name) {
    var i = optNames(product).indexOf(name);
    return (i < 0 || !v) ? null : vals(v)[i];
  }
  /* Greenhouse sizes are "length x width", e.g. 8'5" x 6'3" - nominal length is the feet figure. */
  function feet(size) {
    var m = String(size || '').match(/^\s*(\d+)\s*'/);
    return m ? parseInt(m[1], 10) : null;
  }
  function lengthOf(item) {
    var m = String(item || '').match(/(\d+)'\s*Long/i);
    return m ? parseInt(m[1], 10) : null;
  }

  /* Every available item in an accessory product, in the greenhouse's finish where that applies. */
  function choices(r, p, finish) {
    if (!p || !p.variants) return [];
    var names = optNames(p), ii = names.indexOf('Item'), fi = names.indexOf('Finish');
    if (ii < 0) ii = 0;
    var inc = rx(r.include), exc = rx(r.exclude), seen = {}, out = [];
    p.variants.forEach(function (v) {
      if (v.available === false) return;
      var vv = vals(v), item = vv[ii];
      if (!item || seen[item]) return;
      if (inc && !inc.test(item)) return;
      if (exc && exc.test(item)) return;
      if (fi >= 0 && vv[fi] !== (finish || 'Aluminium Finish')) return;
      seen[item] = 1;
      out.push({ item: item, v: v, finished: fi >= 0 });
    });
    return out;
  }

  /* What a row offers for the chosen greenhouse: { list, pick } or null to hide it. */
  function offer(r, size, finish) {
    var list = choices(r, acc[r.key], finish);
    if (!list.length) return null;
    if (r.mode === 'length') {
      var want = feet(size);
      if (!want) return null;
      var best = null;
      list.forEach(function (c) {
        var L = lengthOf(c.item);
        if (L && L >= want && (!best || L < lengthOf(best.item))) best = c;
      });
      return best ? { list: [best], pick: best, len: lengthOf(best.item) } : null;
    }
    var st = state[r.key], pick = null, def = rx(r.def);
    if (st && st.item) list.forEach(function (c) { if (c.item === st.item) pick = c; });
    if (!pick && def) list.forEach(function (c) { if (!pick && def.test(c.item)) pick = c; });
    return { list: list, pick: pick || list[0] };
  }

  function rowHtml(r, o, folded, powder) {
    var title = r.title.replace('{len}', o.len || '');
    var sel = '';
    if (o.list.length > 1) {
      sel = '<select class="lgb-adds__select" data-sel="' + r.key + '" aria-label="' + esc(title) + '">' +
        o.list.map(function (c) {
          return '<option value="' + esc(c.item) + '"' + (c === o.pick ? ' selected' : '') + '>' +
            esc(c.item) + ' (+' + money(c.v.price) + ')</option>';
        }).join('') + '</select>';
    }
    var note = r.note + (powder && o.pick.finished ? ' Powder coated to match your greenhouse.' : '');
    var q = r.qty ? qtyOf(r.key) : 1;
    var qty = r.qty ? '<span class="lgb-adds__qty" aria-label="How many">' +
      '<button type="button" data-q="-1" data-k="' + r.key + '" aria-label="One fewer">&minus;</button>' +
      '<output>' + q + '</output>' +
      '<button type="button" data-q="1" data-k="' + r.key + '" aria-label="One more">+</button></span>' : '';
    return '<div class="lgb-adds__row' + (folded ? ' lgb-adds__fold' : '') + '" data-row="' + r.key + '">' +
      '<input type="checkbox" id="lgbAdds_' + r.key + '">' +
      '<div class="lgb-adds__body">' +
        '<label class="lgb-adds__label" for="lgbAdds_' + r.key + '">' + esc(title) +
          '<span class="lgb-adds__note">' + esc(note) + '</span>' +
        '</label>' + sel + qty +
      '</div>' +
      '<span class="lgb-adds__price">+' + money(o.pick.v.price * q) + '</span>' +
    '</div>';
  }

  function build(offers, powder) {
    var wrap = document.createElement('div');
    wrap.className = 'lgb-adds' + (expanded ? ' is-open' : '');
    wrap.id = 'lgbAddons';
    var shown = 0, hidden = 0;
    var html = '<div class="lgb-adds__head">' + esc(CFG.heading || 'Finish it properly') + '</div>';
    CFG.rows.forEach(function (r) {
      if (!offers[r.key]) return;
      var folded = shown >= VISIBLE;
      if (folded) hidden++; else shown++;
      html += rowHtml(r, offers[r.key], folded, powder);
    });
    if (hidden > 0) {
      html += '<button type="button" class="lgb-adds__more" id="lgbAddsMore">' +
        '<span class="lgb-adds__more-open">' + hidden + ' more option' + (hidden > 1 ? 's' : '') + '</span>' +
        '<span class="lgb-adds__more-close">Show fewer</span>' +
      '</button>';
    }
    html += '<div class="lgb-adds__status" id="lgbAddsStatus"></div>';
    wrap.innerHTML = html;

    wrap.addEventListener('change', function (e) {
      var t = e.target;
      var row = t.closest ? t.closest('.lgb-adds__row') : null;
      if (!row) return;
      var key = row.getAttribute('data-row');
      state[key] = state[key] || {};
      if (t.type === 'checkbox') {
        state[key].on = t.checked;
        row.classList.toggle('is-on', t.checked);
      } else if (t.tagName === 'SELECT') {
        state[key].item = t.value;
        state[key].on = true; /* choosing an item means they want it */
        lastKey = null;
        render();
      }
    });
    wrap.addEventListener('click', function (e) {
      var qb = e.target.closest ? e.target.closest('[data-q]') : null;
      if (qb) {
        e.preventDefault();
        var k = qb.getAttribute('data-k');
        state[k] = state[k] || {};
        state[k].qty = Math.max(1, Math.min(10, qtyOf(k) + Number(qb.getAttribute('data-q'))));
        state[k].on = true;
        lastKey = null;
        render();
        return;
      }
      var more = e.target.closest ? e.target.closest('#lgbAddsMore') : null;
      if (!more) return;
      e.preventDefault();
      expanded = !expanded;
      wrap.classList.toggle('is-open', expanded);
    });
    return wrap;
  }

  function render() {
    var f = mainForm();
    if (!f || !product) return;
    var v = currentVariant();
    if (!v) return;
    var size = optOf(v, 'Size'), finish = optOf(v, 'Finish') || 'Aluminium Finish';
    var powder = /powder/i.test(finish);

    var offers = {}, any = false;
    CFG.rows.forEach(function (r) {
      var o = offer(r, size, finish);
      if (o) { offers[r.key] = o; any = true; }
    });

    var existing = document.getElementById('lgbAddons');
    var key = [v.id].concat(CFG.rows.map(function (r) {
      return offers[r.key] ? offers[r.key].pick.v.id + 'x' + qtyOf(r.key) : '';
    })).join('|');

    if (!any) {
      if (existing) existing.remove();
      lastKey = null;
      return;
    }
    if (existing && key === lastKey && f.contains(existing)) return;
    if (existing) existing.remove();

    var box = build(offers, powder);
    CFG.rows.forEach(function (r) {
      var o = offers[r.key];
      box.setAttribute('data-' + r.key, o ? o.pick.v.id : '');
      box.setAttribute('data-pc-' + r.key, (o && o.pick.finished) ? '1' : '');
      var cb = box.querySelector('#lgbAdds_' + r.key);
      if (cb && state[r.key] && state[r.key].on) {
        cb.checked = true;
        cb.closest('.lgb-adds__row').classList.add('is-on');
        if (cb.closest('.lgb-adds__fold') && !expanded) {
          expanded = true;
          box.classList.add('is-open');
        }
      }
    });

    var buttons = f.querySelector('.product-form-buttons');
    if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(box, buttons);
    else f.appendChild(box);
    lastKey = key;
  }

  /* The building's own line-item properties (e.g. "Powder coating colour") so nothing is lost. */
  function formProps(f) {
    var props = {};
    f.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (el.disabled || !el.value) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = el.value;
    });
    return props;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="add"]') : null;
    if (!btn) return;
    var box = document.getElementById('lgbAddons');

    var f = btn.closest('form[data-type="add-to-cart-form"]') || mainForm();
    var inp = idInputOf(f);
    if (!inp || !inp.value) return;

    /* Let the powder colour check do its job first - never add without a colour. */
    var pc = document.getElementById('lgb-pc-colour-select');
    if (pc && !pc.disabled && !pc.value) return;

    var extras = [];
    if (box) CFG.rows.forEach(function (r) {
      var cb = box.querySelector('#lgbAdds_' + r.key);
      var id = box.getAttribute('data-' + r.key);
      if (cb && cb.checked && id) extras.push({ id: Number(id), pc: box.getAttribute('data-pc-' + r.key) === '1', q: r.qty ? qtyOf(r.key) : 1 });
    });
    /* Build options (base, bar capping, doors...) from the build panel, when there is one. */
    try { if (window.LGBEliteBuildPicks) window.LGBEliteBuildPicks().forEach(function (x) { extras.push({ id: Number(x.id), pc: !!x.pc, q: 1 }); }); } catch (err) {}
    if (!extras.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var status = document.getElementById('lgbAddsStatus') || document.getElementById('lgbBuildStatus');
    var original = btn.innerHTML;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    if (status) { status.textContent = ''; status.className = 'lgb-adds__status'; }

    var qtyInput = f.querySelector('[name="quantity"]');
    var n = qtyInput && parseInt(qtyInput.value, 10) > 0 ? parseInt(qtyInput.value, 10) : 1;
    var props = formProps(f);
    var colour = props['Powder coating colour'];
    var powder = /powder/i.test(optOf(currentVariant(), 'Finish') || '');

    var building = { id: Number(inp.value), quantity: n };
    if (Object.keys(props).length) building.properties = props;
    var items = [building];
    extras.forEach(function (x) {
      var it = { id: x.id, quantity: n * (x.q || 1) };
      if (powder && colour && x.pc) it.properties = { 'Powder coating colour': colour };
      items.push(it);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'Could not add to basket'); });
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function (err) {
      busy = false;
      btn.disabled = false;
      btn.innerHTML = original;
      if (status) {
        status.textContent = (err && err.message) ? err.message : 'Sorry, something went wrong — please try again.';
        status.className = 'lgb-adds__status err';
      }
    });
  }, true);

  function load(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function start() {
    var rows = CFG.rows, handles = {}, list = [];
    rows.forEach(function (r) { if (!handles[r.handle]) { handles[r.handle] = 1; list.push(r.handle); } });
    Promise.all([load(CFG.productHandle)].concat(list.map(load)))
      .then(function (res) {
        product = res[0];
        var byHandle = {};
        list.forEach(function (h, i) { byHandle[h] = res[i + 1]; });
        rows.forEach(function (r) { acc[r.key] = byHandle[r.handle]; });
        if (!product || !product.variants) return;
        render();
        setInterval(render, 400);
      }).catch(function (err) {
        console.warn('LGB Elite extras unavailable:', err);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
